module.exports = __webpack_public_path__ + "static/media/s1.6bd70847.jpg";